import styled from '@emotion/styled'

export default styled(({ className }) => {
  return <span className={className}>(optional)</span>
})`
  color: ${props => props.theme.color.monochrome.mediumDark};
`
